import translates from './ar.json';
import restNotifications from './notifiers.json';

export default {
  ar: { ...translates, ...restNotifications },
};
